/**
 * @name appApiUrl
 * @description
 * This is config file, it include the api urls of the application
 * Define Settings the object way(based on requirement):
 * @example
 * {paramsName}:{value}
 * @constant appApiUrl
 * @type {CommonBase}
 */

const BROADCAST_SETTINGS: string = 'broadcast-settings'
const USER_MEDIA: string = 'user-media'
const AUTH: string = 'auth';
const USERS: string = 'users';
const RECORDING:string = 'recordings';
export const appApiUrl = {
  auth: {
    login: 'auth/login',
    checkEmail: 'auth/check-email',
    signup: 'auth/signup',
    changePassword: 'auth/change-password',
    confirmEmail: 'auth/confirm-email',
    forgotPass: 'auth/forgot-password',
    resetPass: 'auth/reset-password',
    validateToken: 'auth/reset-token',
    refreshToken: 'auth/refresh-token',
    googleSignIn: 'auth/google-signin'
  },
  users: {
    role: 'users/role',
    subscription: 'users/subscription',
    updateCard: 'users/update-card',
    card: 'users/card',
    billingInfo: 'users/billing-info',
    planQuotaDetail: 'users/plan-quota-detail',
    changeSubscription: 'users/change-subscription',
    timezone: 'users/timezone',
    referralCode: 'users/referralCode',
    userInfo: 'users/info',
    onBoarding: 'users/on-boarding',
    invoices: 'users/invoices',
    buyStorageAddon: 'users/buy-storage-addon',
    unsubscribe: 'users/unsubscribe',
    cancellationOptions: 'users/cancellation-options',
    subscriptionCancellation: 'users/subscription-cancellation',
    subscriptionReactivate: 'users/subscription-reactivate',
    subscriptionRemove: 'users/subscription-scheduled-remove',
    subscriptionDiscountedPaid: 'users/subscription-discounted-paid'
  },
  session:
  {
    default: 'sessions',
    rating: 'sessions/rating',
    confSetting: 'sessions/conference-setting',
    guest: 'sessions/guest',
    guestRoom: 'sessions/guest-room',
    hostRoom: 'sessions/host-room',
    shareFiles: 'sessions/share-session-files',
    getSharedFiles: 'sessions/get-share-file-by-token',
    chatMeta: 'sessions/chat-meta',
    waitingParticipant: 'sessions/waiting-participant',
    conferenceState: 'sessions/conference-state/'
  },
  referral: {
    default: 'referral',
    sentTo: 'referral/sent-to',
    invite: 'referral/invite',
    code: 'referral/code',
    stats: 'referral/stats',
    clicked: 'referral/clicked',
    saveInviteSingupStat: 'referral/save-invite-at-singup',
    getReferralCodeDetail: 'referral/get-referral-code-detail',
    getAppliedReferralCodeDetail: 'referral/get-applied-referral-code-detail'
  },
  confSetting:
  {
    default: 'conference-setting'
  },

  dolby: {
    default: 'dolby',
    token: 'dolby/token',
    startRtmp: 'dolby/start-rtmp',
    stopRtmp: 'dolby/stop-rtmp'
  },
  profile: {
    default: 'profile',
    changeColor: 'profile/change-color',
    uploadLogo: 'profile/upload-logo',
    customizeRoom: 'profile/customize-room',
    deleteLogo: 'profile/logo',
    tagSetting: 'profile/tagSetting',
    customizeSetting: 'profile/customizeSetting',
    broadCastSetting: 'profile/broadcast-setting'
  },
  attribute: 'attribute',
  recording: {
    default: `${RECORDING}`,
    saveLocalMeta: `${RECORDING}/local-meta-data`,
    updateLocalMeta: `${RECORDING}/file-upload-meta-data/`,
    sessionState: `${RECORDING}/session-state/`,
    lowStorage: `${RECORDING}/low-storage/`,
    count: `${RECORDING}/count`,
    getRecordingBySession: `${RECORDING}/get-recording-by-session/`,
    downloadFile: `${RECORDING}/download-file`,
    downloadFileSharedWith: `${RECORDING}/download-file-shared-with`,
    createOrGetRecordingFile: `${RECORDING}/create-or-get-recordingId`,
    checkFileExistOnCloud: `${RECORDING}/check-file-exist-on-cloud`,
    getfileMetaS3: `${RECORDING}/get-file-meta-s3`,
    deleteByFilename: `${RECORDING}/delete`,
    deleteNotUploaded: `${RECORDING}/delete-not-uploaded`,
    getUrl: `${RECORDING}/url`
  },
  product: {
    plans: 'products/plans'
  },
  broadCastSetting: {
    default: BROADCAST_SETTINGS,
    facebook: `${BROADCAST_SETTINGS}/facebook`,
    google: `${BROADCAST_SETTINGS}/google`,
    getBySessionId: `${BROADCAST_SETTINGS}/session`,
    token: `${BROADCAST_SETTINGS}/token`,
    disconnect: `${BROADCAST_SETTINGS}/disconnect`,
    isAppInstalledInGroup: `${BROADCAST_SETTINGS}/is-app-installed-fb-group`,
    lnConnect: `${BROADCAST_SETTINGS}/linkedIn-connect`,
    linkedinDestination: `${BROADCAST_SETTINGS}/linkedin-destination`,
    scheduleLinkedin: `${BROADCAST_SETTINGS}/schedule-linkedin-live-video`,
    registerLiveVideoLinkedin: `${BROADCAST_SETTINGS}/register-live-video-linkedin`,
    updateScheduleLiveVideoLinkedin: `${BROADCAST_SETTINGS}/update-schedule-linkedin-live-video`,
    ugcPostLinkedin: `${BROADCAST_SETTINGS}/linkedin-ugc-post`,
    checkLiveVideoStatusLinkedin: `${BROADCAST_SETTINGS}/check-live-video-status`,
    endLinkedinLiveVideo: `${BROADCAST_SETTINGS}/end-linkedin-live-video`,
    checkLinkedinContentAccess: `${BROADCAST_SETTINGS}/check-content-access-linkedin`,
    updateLinkedinLiveVideoAtAvailable: `${BROADCAST_SETTINGS}/update-linkedin-live-video-at-available`,
    checkLiveVideoStatusByMediaId: `${BROADCAST_SETTINGS}/check-live-vide-status-linkedin/`,
  },

  userMedia: {
    default: USER_MEDIA,
    intro: `${USER_MEDIA}/intro`,
    media: `${USER_MEDIA}/media`,
    volume: `${USER_MEDIA}/volume`,
    active: `${USER_MEDIA}/active`,
    delete: `${USER_MEDIA}/delete`,
    mute: `${USER_MEDIA}/mute`
  }

};
